var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"bsHead"},[_c('h3',[_vm._v("検索結果")]),_c('PageSelect')],1),_c('Books'),_c('div',{staticClass:"bsFoot"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }